import { Component, Input } from '@angular/core';
import get from 'lodash/get';

@Component({
  selector: 'app-error-list',
  template: `
  <div *ngIf="errorMessage" class="invalid-feedback d-inline-block" role="alert" aria-live="polite">
    <span class="material-icons-round icon-sm me-1">error_outline</span>
    <span [innerHTML]="errorMessage"></span>
  </div>
  `
})
export class ErrorListComponent {
  @Input()
  formErrors: any;

  @Input()
  key: string;

  get displayErrors(): boolean {
    return this.key in this.formErrors && get(this.formErrors, this.key) !== '';
  }

  get errorMessage(): string {
    return get(this.formErrors, this.key) as string;
  }
}
